module.exports = __webpack_public_path__ + "img/QUANTUM FRSOLUTIONS TP.090c466f.png";